var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-inner"},[_c('div',{staticClass:"wly-body-wrapper"},[_c('div',{staticClass:"wly-body-inner"},[_c('BasicHeader'),_c('div',{staticClass:"doc-container"},[_c('DocContainer')],1)],1)]),_c('Footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }